<template>
	<div>
		<button @click.prevent="submitForm" id="custom-button-submit" type="submit" class="btn" :class="classtype">{{ message }}</button>
	</div>
</template>

<script>
// TODO: add datepicker and select checks!!

/*
How To use
<button-submit
	classtype="btn-primary"
	message="Enviar"
></button-submit>
	<button-submit classtype="btn-default" message="Enviar"></button-submit>
*/

var $ = require('jquery')

export default{
	props:['classtype', 'message'],
	methods: {
		submitForm(){
			var err = this.checkErrors()
			console.log('flag1')
			if (err === 0) {
        var form = document.querySelector('form')
        var formData = new FormData(form)
				console.log('flag3')
        $.ajax({
          method: 'POST',
          url: '/send_mail.php',
          data: formData,
          processData: false,
          contentType: false,
          cache: false,
          success: () => {
             $('input, textarea').each(function(index, input) {
                $(input).val('')
            })
						console.log('flag3')
            $('input[type="checkbox"]').each(function(index, checkbox){
                $(checkbox).click()
            })
            alert('message sent')
						console.log('flag4')
          },
          error: (data) => {
            alert('ERROR ERROR ERROR')
						console.log('flag5')
          }
		    })
      }
    },
		checkErrors(){
			var error = 0
			$('input, select, textarea ').each(function(index, input) {
				if(!$(input).val() && !$(input).hasClass('no-error-field') && $(input).is(':visible')){
				 //	$(input).click()
				}
			})

			$('input, textarea').each(function(index, input) {
				if(!$(input).val() && !$(input).hasClass('no-error-field') && $(input).is(':visible')){
					$(input).addClass('error')
					error++
				} else{
					$(input).removeClass('error')
				}
			})

			$('select').each(function(index, select) {
				if($(select).prop('selectedIndex') === 0 && !$(select).hasClass('no-error-field') && !$(select).is(':visible')){
					$(select).addClass('error')
					error++
				} else {
					$(select).removeClass('error')
				}
			})

      $('input[type="checkbox"]').each(function(index, checkbox){
        if(!$(checkbox).is(':checked')){
          $(checkbox).addClass('error')
          error++
        } else {
          $(checkbox).removeClass('error')
        }
      })

			return error
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~varmix';
  $primary: $red;
  $secondary: $dark-red;
.btn-default{
	background-color: $red;
	border: 2px solid $primary;
	border-radius: 0;
	color:white;
	text-align: center;
	width: 200px;
	margin-bottom: 50px;
	&:focus{
		outline: 0;
	}
	&:hover{
		background-color: $dark-red;
		border-color: $secondary;
		color: white;
	}
}

.btn-primary{
	background-color: transparent;
	border: 2px solid $primary;
	border-radius: 0;
	color: $primary;
	text-align: center;
	width: 200px;
	margin-bottom: 50px;
	padding: 15px;
	&:focus{
		outline: 0;
	}
	&:hover{
		border-color: $secondary;
		color: $secondary;
	}
}

.center-button{
		@include celphone{
			display: block;
			margin: 25px auto;
			float: none !important;
		}
	}
</style>



// WEBPACK FOOTER //
// ButtonSubmit.vue?09fbc0b7